import { useCache, useController, useSuspense } from '@rest-hooks/react'
import moment from 'moment'

import { ROLE_NONE } from '../constants/roles'
import { AuthInfo, CheckLogin } from '../resources/auth'
import { findCookie } from '../utils/cookies'

export const useAuthInfo = () => {
  const info = useSuspense(AuthInfo.authInfoShape(), {})
  const controller = useController()
  const invalidateLogin = () => controller.invalidate(CheckLogin.checkLoginShape(), {})

  if (info.role === ROLE_NONE) {
    console.log('Role is invalid so invalidating login')
    invalidateLogin()
  }

  return info
}

export const useCheckLogin = () => {
  // Use useSuspense to actually fetch the login status from the server
  // This ensures we verify the JWT_TOKEN cookie is valid after SAML redirect
  // The parent Suspense boundary in App.jsx will show LoadingPage while fetching
  const result = useSuspense(CheckLogin.checkLoginShape(), {})
  if (!result) return false
  return result.expires > moment().unix()
}

export const useIsAuthorized = () => {
  const auth = findCookie('UNAUTHORIZED')
  return parseInt(auth) !== -1
}
